"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_1 = require("./styled");

var Designs;

(function (Designs) {
  Designs["Default"] = "default";
  Designs["Primary"] = "primary";
  Designs["Dark"] = "dark";
  Designs["Danger"] = "danger";
  Designs["Disabled"] = "disabled";
})(Designs = exports.Designs || (exports.Designs = {}));

var Sizes;

(function (Sizes) {
  Sizes["Tiny"] = "tiny";
  Sizes["Small"] = "small";
  Sizes["Default"] = "default";
})(Sizes = exports.Sizes || (exports.Sizes = {}));
/**
 * Button component - used for buttoney things
 *
 * **Button.Designs**: reference for available designs
 *
 * **Button.Sizes**: reference for a available sizes
 */


var Button = function Button(_a) {
  var children = _a.children,
      _a$design = _a.design,
      design = _a$design === void 0 ? Designs.Default : _a$design,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$href = _a.href,
      href = _a$href === void 0 ? undefined : _a$href,
      _a$newTab = _a.newTab,
      newTab = _a$newTab === void 0 ? false : _a$newTab,
      rest = __rest(_a, ["children", "design", "disabled", "href", "newTab"]);

  var targets = newTab && !(href === undefined) ? {
    target: "_blank",
    rel: "noopenner noreferrer"
  } : {};
  var hrefProp = typeof href === "undefined" ? {} : {
    href: href
  };
  return react_1["default"].createElement(styled_1.StyledButton, Object.assign({
    design: disabled ? Designs.Disabled : design,
    as: href ? "a" : "button"
  }, hrefProp, targets, rest), react_1["default"].createElement("span", null, children));
};

Button.Designs = Designs;
Button.Sizes = Sizes;
exports["default"] = Button;